import { HttpClientModule } from '@angular/common/http';
import { Injector, NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AngularMaterialModule } from './modules/angular-material/angular-material.module';

// Gridster
import { GridsterModule } from 'angular-gridster2';

// Graphing
import { NgChartsModule } from 'ng2-charts';

// My Components
import {
  NgxMatDateFormats, NgxMatDatetimePickerModule,
  NgxMatTimepickerModule, NGX_MAT_DATE_FORMATS
} from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule, NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular-material-components/moment-adapter';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AnalyzeComponent } from 'components/analyze/analyze.component';
import { QueryNameComponent } from 'components/analyze/query-name/query-name.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AuthenticatedInterceptor } from 'services/authentication/http-interceptor';
import { LoginGuardService } from 'services/authentication/login-guard/login-guard.service';
import { RoleGuardService } from 'services/authentication/role-guard/role-guard.service';
import { Components } from './components/components';
import { MessageBoxComponent } from './components/message-box/message-box.component';
import { TranslationService } from './services/translation/translation.service';
import { WidgetsComponents } from './widgets/widgets-components';

export const MOMENT_DATETIME_WITH_SECONDS_FORMAT = 'YYYY-MM-DD HH:mm';

// If using Moment
const CUSTOM_MOMENT_FORMATS: NgxMatDateFormats = {
  parse: {
    dateInput: MOMENT_DATETIME_WITH_SECONDS_FORMAT,
  },
  display: {
    dateInput: MOMENT_DATETIME_WITH_SECONDS_FORMAT,
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export let Service: Injector;

@NgModule({
  declarations: [
    AppComponent,
    Components,
    WidgetsComponents,
    MessageBoxComponent,
    AnalyzeComponent,
    QueryNameComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    GridsterModule,
    NgChartsModule,
    AngularMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslationService.forRoot(),
    ColorPickerModule,
    NgxSpinnerModule,
    DragDropModule,
    NgxMatMomentModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    MatSnackBarModule
  ],
  exports: [
    NgxMatMomentModule,
    NgxMatDatetimePickerModule,
  ],
  providers: [
    LoginGuardService,
    RoleGuardService,
    AuthenticatedInterceptor,
    { provide: NGX_MAT_DATE_FORMATS, useValue: CUSTOM_MOMENT_FORMATS },
    { provide: NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    private injector: Injector
  ) {
    Service = this.injector;
  }
}
